// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { NotificationDef, NotificationRef, NotificationUpdateData } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace NotificationActions {
  export class GetAllNotifications {
    static readonly type = '[Notification] GetAllNotification';
    readonly type = GetAllNotifications.type;
  }

  export class InitNotificationCount {
    static readonly type = '[Notification] InitNotificationsCount';
    readonly type = InitNotificationCount.type;
  }

  export class InitNotification {
    static readonly type = '[Notification] InitNotifications';
    readonly type = InitNotification.type;
  }
  export class CountNotifications {
    static readonly type = '[Notification] CountNotifications';
    readonly type = CountNotifications.type;
  }

  export class CloseNotificationsConnection {
    static readonly type = '[Notification] CloseNotificationsConnection';
    readonly type = CloseNotificationsConnection.type;
  }

  export class GetNotificationById {
    static readonly type = '[Notification] GetNotificationById';
    readonly type = GetNotificationById.type;
  }

  export class UpdateNotification {
    static readonly type = '[Notification] UpdateNotification';
    constructor(
      public notificationData: Partial<NotificationUpdateData>,
      public ref: NotificationRef,
    ) {}
  }

  export class DeleteNotifications {
    static readonly type = '[Notification] DeleteNotifications';
    constructor(public refs: NotificationRef[]) {}
  }

  export class PaginateQueryNotification {
    static readonly type = '[Notification] PaginateQueryNotification';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public notificationId?: string,
    ) {}
  }
  export class NotificationError {
    static readonly type = '[Notification] NotificationError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Notification] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Notification] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public notificationId?: string,
    ) {}
  }

  export class UpdateNotificationResult {
    static readonly type = '[Notification] UpdateNotificationResult';
    constructor(public data: Array<TypesaurusCoreDoc<NotificationDef> | null | undefined>) {}
  }
}
